import React, { useEffect } from 'react';
import { Menu, X, Sparkles, Code, Palette } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './Header.module.css';
import logoImage from '../../images/main-logo.png';

const Header = ({ mode, setMode, menuOpen, setMenuOpen, scrolled }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleNavClick = (sectionId) => {
    if (sectionId === 'contact') {
      navigate('/contact');
      setMenuOpen(false);
      return;
    }

    if (!isHomePage) {
      sessionStorage.setItem('portfolioMode', mode);
      sessionStorage.setItem('scrollToSection', sectionId);
      navigate('/');
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMenuOpen(false);
  };

  const handleModeChange = (newMode) => {
    sessionStorage.setItem('portfolioMode', newMode);
    if (isHomePage) {
      setMode(newMode);
    } else {
      navigate('/');
      setTimeout(() => setMode(newMode), 100);
    }
  };

  useEffect(() => {
    const savedMode = sessionStorage.getItem('portfolioMode');
    const scrollTo = sessionStorage.getItem('scrollToSection');
    
    if (savedMode && isHomePage) {
      setMode(savedMode);
    }
    
    if (scrollTo && isHomePage) {
      setTimeout(() => {
        const element = document.getElementById(scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
        sessionStorage.removeItem('scrollToSection');
      }, 100);
    }
  }, [isHomePage, setMode]);
  return (
    <header className={`${styles.header} ${scrolled ? styles.headerScrolled : ''}`}>
      <nav className={styles.nav}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}>
            <img src={logoImage} alt="Logo" width={40} height={40} />
          </div>
        </div>

       

        <div className={styles.rightSection}>
          <div className={styles.desktopMenu}>
            {mode === 'web' ? (
              <>
                <button onClick={() => handleNavClick('projects')} className={styles.navLink}>Projects</button>
                <button onClick={() => handleNavClick('services')} className={styles.navLink}>Services</button>
                <button onClick={() => handleNavClick('contact')} className={styles.navLink}>Contact</button>
              </>
            ) : (
              <>
                <button onClick={() => handleNavClick('about')} className={styles.navLink}>About</button>
                <button onClick={() => handleNavClick('experience')} className={styles.navLink}>Experience</button>
                <button onClick={() => handleNavClick('portfolio')} className={styles.navLink}>Portfolio</button>
                <button onClick={() => handleNavClick('skills')} className={styles.navLink}>Skills</button>
                <button onClick={() => handleNavClick('contact')} className={styles.navLink}>Contact</button>
              </>
            )}
          </div>

          <div className={styles.toggleContainer}>
            <button
              onClick={() => handleModeChange('graphic')}
              className={`${styles.toggleBtn} ${mode === 'graphic' ? styles.toggleBtnActiveGraphic : styles.toggleBtnInactive}`}
            >
              <Palette size={16} />
              <span className={styles.toggleText}>Graphic Design</span>
            </button>
            <button
              onClick={() => handleModeChange('web')}
              className={`${styles.toggleBtn} ${mode === 'web' ? styles.toggleBtnActiveWeb : styles.toggleBtnInactive}`}
            >
              <Code size={16} />
              <span className={styles.toggleText}>Web Design</span>
            </button>
          </div>
        </div>

        <button onClick={() => setMenuOpen(!menuOpen)} className={styles.menuButton}>
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        
      </nav>

      <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ''}`}>
        <div className={styles.mobileMenuContent}>
          {mode === 'web' ? (
            <>
              <button onClick={() => handleNavClick('projects')} className={styles.navLink}>Projects</button>
              <button onClick={() => handleNavClick('services')} className={styles.navLink}>Services</button>
              <button onClick={() => handleNavClick('contact')} className={styles.navLink}>Contact</button>
            </>
          ) : (
            <>
              <button onClick={() => handleNavClick('about')} className={styles.navLink}>About</button>
              <button onClick={() => handleNavClick('experience')} className={styles.navLink}>Experience</button>
              <button onClick={() => handleNavClick('portfolio')} className={styles.navLink}>Portfolio</button>
              <button onClick={() => handleNavClick('skills')} className={styles.navLink}>Skills</button>
              <button onClick={() => handleNavClick('contact')} className={styles.navLink}>Contact</button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;